import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-13">
      <div ref={modalRef} className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-14">
        <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-15">
          <h3 id="modal-title" className="text-xl font-serif font-bold text-[#1F2937]" data-id="element-16">
            {title}
          </h3>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors" data-id="element-17">
            <X className="w-5 h-5" data-id="element-18" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto" data-id="element-19">
          <div className="prose prose-sm max-w-none text-gray-600" data-id="element-20">
            {children}
          </div>
        </div>
      </div>
    </div>;
}